<template>
    <div class="item" @click="onPressNav('lecturerDetail')">
         <div class="center">
            <img :src="item.img" alt="">
            <div>
                <div>
                    <p>{{item.title}}</p>
                    <div>{{item.tag}}</div>
                </div>
                <p>{{item.tip}}</p>
                <span>加入时间：{{item.time}}</span>
            </div>
        </div>
        <div class="footer">
            <p>课程消费:<span>{{item.classPrice}}元</span></p>
            <p>商城消费:<span>{{item.shopPrice}}元</span></p>
        </div>
    </div>
</template>
<script>
export default {
    name: "lecturerItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
};
</script>
<style lang="less" scoped>
.item {
    padding: 10px;
    border: 1px dashed #f3f0ee;

    .center {
        margin-bottom: 5px;
        display: flex;

        > img {
            width: 80px;
            height: 80px;
            margin-right: 10px;
            object-fit: cover;
        }

        > div {
            flex: 1;
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            > div {
                display: flex;
                align-items: center;

                > p {
                    flex: 1;
                    font-size: 14p;
                    color: #333;
                }

                div {
                    padding: 2px 8px;
                    border-radius: 4px;
                    border: 1px solid #7181EB;
                    font-size: 12px;
                    color: #7181EB;
                }
            }

            > p {
                font-size: 13px;
                color: #333;
            }

            > span {
                font-size: 13px;
                color: #999;
            }
        }
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        p {
            font-size: 13px;
            color: #333;

            span {
                color: #FF0000;
            }
        }
    }
}
</style>